import { Gutters } from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useEphemeralStore } from '../../state/useEphemeralStore'
import { NavigationView } from '../layout/NavigationView'
import { HotelDetailsAvailability } from './hotelInfo/hotelDetailsAvailability'
import { HotelDetailsHeader } from './hotelInfo/hotelDetailsHeader'
import { HotelDetailsMain } from './hotelInfo/hotelDetailsMain'
import { HotelImageCarousel } from './hotelInfo/hotelImageCarousel'

export const HotelDetailsPage: FC = () => {
    const { hotelResp } = useEphemeralStore(
        useShallow((s) => ({
            hotelResp: s.hotelResp,
        }))
    )

    if (!hotelResp) {
        return null
    }

    const images = hotelResp.hotelInfo.images

    return (
        <NavigationView
            usePageTransition
            backButtonAction={() => {
                window.goBack()
            }}
            pictureMode
        >
            <Box display={'grid'}>
                <HotelImageCarousel images={images} />
                <Box display={'grid'} overflow={'hidden'}>
                    <Gutters>
                        <Box display={'grid'} maxWidth={'90vw'}>
                            <HotelDetailsHeader />
                            <HotelDetailsMain />
                            <HotelDetailsAvailability />
                        </Box>
                    </Gutters>
                </Box>
            </Box>
        </NavigationView>
    )
}
